import { render, staticRenderFns } from "./PDPModalPromotionPrivileges.vue?vue&type=template&id=7f01aca5&scoped=true"
import script from "./PDPModalPromotionPrivileges.vue?vue&type=script&lang=js"
export * from "./PDPModalPromotionPrivileges.vue?vue&type=script&lang=js"
import style0 from "./PDPModalPromotionPrivileges.vue?vue&type=style&index=0&id=7f01aca5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f01aca5",
  null
  
)

export default component.exports